import PropTypes from "prop-types";
import styles from "./CategoryBanner.module.css";

/**
 * View component. Displays a category's name with the selected text and fill color.
 */
export function CategoryBanner({ title, textColor, fillColor }) {
  return (
    <div
      className={styles.banner}
      style={{
        backgroundColor: fillColor || "#adb7c0",
        color: textColor,
      }}
    >
      <span>{title}</span>
    </div>
  );
}

CategoryBanner.propTypes = {
  /**
   * Category title
   */
  title: PropTypes.string.isRequired,

  /**
   * Banner text color as a CSS color string
   */
  textColor: PropTypes.string.isRequired,

  /**
   * Banner background color as a CSS color string
   */
  fillColor: PropTypes.string,
};
